import React from "react";
// import { useState } from "react";
import "./App.css"
// import Loading from "./Loading";
import Home from "./components/home";
// import Qrpage from "./components/Qrpage";

export default function App() { 

  return (
    <>
      <Home/>
    </>
  )
}